import { Row } from 'components/grid/wrappers/FlexWrapper';
import { grey } from 'constants/styles/colors';
import styled from 'styled-components';

export const IconWrapper = styled(Row)`
    padding-left: 12px;
    border-left: 1px solid ${grey[600]};
`;
